import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { EscalatedRisk } from '../../_interfaces/EscalatedRisk.model';
import { RepositoryService } from './../../shared/services/repository.service';

@Component({
  selector: 'app-escalated-risk-list',
  templateUrl: './escalated-risk-list.component.html',
  styleUrls: ['./escalated-risk-list.component.css']
})
export class EscalatedRiskListComponent implements OnInit {
  public escalatedRisks: EscalatedRisk[];

  constructor(private repository: RepositoryService, private router: Router) {
  }

  ngOnInit() {
    this.getEscalatedRisks();
  }

  getEscalatedRisks() {
    let apiAddress: string = `escalatedrisks`;

    this.repository.getData(apiAddress)
      .subscribe(res => {
        this.escalatedRisks = res as EscalatedRisk[];
      });
  }

  addNew() {
    let url: string = `/add-escalated`;
    this.router.navigate([url]);
  }

  public editEscalatedRiskRecord(riskId: number) {
    // ToDo - update next line with the correct url for the new edit component - then un-comment
    let riskDetailUrl: string = `/myrisks/edit-escalated/${riskId}`;
    this.router.navigate([riskDetailUrl]);
  }

}
